import React, { Component, Fragment } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

class AddClientFillsToDeal extends Component {
  state = {
    currentDeal: null
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.currentDeal && this.props.currentDeal && !prevState.currentDeal) {
      this.setState({ currentDeal: this.props.currentDeal });
    }
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          {this.state.currentDeal ? (
            <Fragment>
              <DialogTitle id="alert-dialog-title">{this.props.currentDeal.dealName}</DialogTitle>
              <DialogContent>
                <table className="lawyer-observe-data-table">
                  {this.state.currentDeal.createClientUI.map((field, index) => {
                    var value = field.value;
                    if (value === true) value = "כן";
                    else if (value === false) value = "לא";
                    return (
                      <tbody>
                        <tr className={field.isDeleted ? "line-over-txt" : ""}>
                          <td>{field.label}</td>
                          <td>{value}</td>
                          <td>
                            {field.isDeleted ? (
                              <i
                                onClick={() => {
                                  this.toggleIsDeleted(false, index);
                                }}
                                className="material-icons revert-field-from-cli"
                              >
                                replay
                              </i>
                            ) : (
                              <i
                                onClick={() => {
                                  this.toggleIsDeleted(true, index);
                                }}
                                className="material-icons delete-field-from-cli"
                              >
                                block
                              </i>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
                <div className="mt-40">
                  <Button
                    className="mr-20 mt-20"
                    onClick={this.props.rejectClientEdits}
                    color="secondary"
                    variant="contained"
                    size="small"
                  >
                    דחה את כל השינויים
                  </Button>
                  <Button
                    className="mr-20 mt-20"
                    onClick={() => {
                      this.props.approveSelectedEdits(this.state.currentDeal);
                    }}
                    color="secondary"
                    variant="contained"
                    size="small"
                  >
                    שמור שינויים
                  </Button>
                </div>
              </DialogContent>
            </Fragment>
          ) : null}
          <DialogActions>
            <Button onClick={this.cleanAndClosePopup} color="primary">
              לחץ כאן לסגירה ולעריכה במועד אחר
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  cleanAndClosePopup = () => {
    var currentDeal = { ...this.state.currentDeal };
    currentDeal.createClientUI = currentDeal.createClientUI.map((item) => {
      delete item["isDeleted"];
      return item;
    });
    this.setState({ currentDeal }, this.props.closePopup);
  };

  toggleIsDeleted = (isDeleted, index) => {
    var currentDeal = { ...this.state.currentDeal };
    currentDeal.createClientUI[index].isDeleted = isDeleted;

    this.setState({ currentDeal });
  };
}

export default AddClientFillsToDeal;
